import React from 'react';
import { Navigate } from 'react-router-dom';
import { useStore } from '../../context/StoreContext';
import { buildCustomerRoute } from '../../utils/storeUtils';

const CustomerSettingsPage = () => {
  const { storeId } = useStore();
  const profilePath = buildCustomerRoute(storeId, 'customer-profile') || '/customer-profile';

  return <Navigate to={profilePath} replace />;
};

export default CustomerSettingsPage;
